import React from 'react';
import EnergyEntriesStep from './EnergyEntriesStep';
import { useLanguage } from '../../context/LanguageContext';

export const StepTransformation = ({ formData, setFormData, energyFactors, addEntry, updateEntry, removeEntry, isDark, language, categories }) => {
  const { t } = useLanguage();
  return (
    <EnergyEntriesStep
      phase="transformation"
      title={t('productWizard.transformation.title')}
      subtitle={t('productWizard.transformation.subtitle')}
      formData={formData} setFormData={setFormData}
      energyFactors={energyFactors} addEntry={addEntry} updateEntry={updateEntry} removeEntry={removeEntry}
      isDark={isDark} language={language} categories={categories}
    />
  );
};
